import { Chip, useMediaQuery, useTheme } from '@mui/material';
import { WifiOff, Wifi } from '@mui/icons-material';
import useOnlineStatus from '../../hooks/useOnlineStatus';

interface OnlineStatusChipProps {
  compact?: boolean;
}

const OnlineStatusChip = ({ compact }: OnlineStatusChipProps = {}) => {
  const isOnline = useOnlineStatus();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isCompact = compact ?? isMobile;

  return (
    <Chip
      icon={isOnline ? <Wifi /> : <WifiOff />}
      label={!isCompact ? (isOnline ? 'Online' : 'Offline') : undefined}
      color={isOnline ? 'success' : 'error'}
      variant="outlined"
      size="small"
      sx={{
        height: isCompact ? 28 : 32,
        px: isCompact ? 0.5 : 1.5,
        minWidth: isCompact ? 28 : 'auto',
        fontSize: '0.75rem',
        fontWeight: 500,
        borderRadius: isCompact ? '50%' : 2,
        borderWidth: 1.5,
        transition: 'all 0.2s ease-in-out',
        '& .MuiChip-label': {
          px: isCompact ? 0 : 0.5,
          py: 0.25
        },
        '& .MuiChip-icon': {
          fontSize: isCompact ? '14px' : '16px',
          ml: isCompact ? 0 : 0.5,
          mr: isCompact ? 0 : -0.25
        }
      }}
    />
  );
};

export default OnlineStatusChip;
